import { axiosApi as axios } from '../helpers/axiosApi';
import { getCookie } from './helpers';
const ATTACHMENTS_API = "/studies/attachments/";

export const getAttachments = (params) => {
  return axios.get(ATTACHMENTS_API, {params: params}).then(res => res.data);
}

export const addAttachment = (attachment) => {
  return axios.post(ATTACHMENTS_API, attachment, {
    headers: {
      "Authorization": `Bearer ${getCookie('access')}`
    }
  }).then(res => res.data);
}

export const updateAttachment = (attachment, id) => {
  return axios.put(`${ATTACHMENTS_API}${id}/`, attachment, {
    headers: {
      "Authorization": `Bearer ${getCookie('access')}`
    }
  }).then(res => res.data);
}

export const deleteAttachment = (id) => {
  return axios.delete(`${ATTACHMENTS_API}${id}/`, {
    headers: {
      "Authorization": `Bearer ${getCookie('access')}`
    }
  }).then(res => res);
}
